import RedesignDescriptor from './cart-elements-redesign';
import ConnectandPayDescriptor from './cart-elements-canteen';
import AramarkDescriptor from './cart-elements-aramark';
import CompanyKitchenDescriptor from './cart-elements-companykitchen';
import RefiveDescriptor from './cart-elements-refive';
import Settings from 'src/Settings';
import {IMenuCategory, ProductCategory} from 'src/types/ProductCategory';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: ConnectandPayDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export type RenderItemProps = {
  item: ProductCategory;
  index?: number;
  onCategoryPress?: (item: ProductCategory) => void;
  selectedCategory?: string | number;
  categoriesLength?: number;
};
export type RenderMenuItemProps = {
  item: IMenuCategory;
  index?: number;
  onMenuItemPress?: (item: IMenuCategory, isPlusIconPressed?: boolean) => void;
  selectedCategory?: string | number;
  categoriesLength?: number;
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
